module.exports = __webpack_public_path__ + "static/images/filter.4e7465b66bc52ef08bc4862156118f12.svg";